module.exports = __webpack_public_path__ + "static/media/carat_Diamonds.bcf1e1f6.jpg";